import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as R from 'ramda';
import * as _ from 'lodash';
import moment from 'moment';
import Select from 'react-select-nested-group';
import { subDays } from 'date-fns';
import DateTime from 'react-datetime';
import { DateRangePicker } from 'react-date-range';
import { Popover, PopoverBody } from 'reactstrap';

import Users from '../../ducks/Users';
import Things from '../../ducks/Things';

import { Spinner } from '../common/Spinner/index';

import './index.css';
import Modal from 'react-bootstrap4-modal';

class TroubleShootReport extends Component {

  constructor() {
    super();
    this.state = {
      user: {},
      popoverOpen: false,
      report: false,
      loading: true,
      selectedGroups: [],
      userGroups: [],
      vehicleNumberPlate: [],
      things: [],
      notificationSelected: [],
      notifications: [],
      maxDateRange: new Date(),
      dateRangePicker: {
        selection: {
          // startDate: subDays(new Date(), 7),
          startDate: new Date(),
          endDate: new Date(),
          key: 'selection',
        },
      },
      collapse: [],
      showModal: false,
      lat: 0,
      lng: 0,
      skip: 0,
      downloadUrl: null,
      showSuccessModal: false
    }
  }

  async componentDidMount() {
    let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
    let userData = JSON.parse(localStorage.getItem("user"));
    let userGroups = userData['user']['group'];
    
    if (userGroups['child']) {
      let groups = userGroups['child'];
      const mappedGroups = R.map(group => ({ value: group._id, label: `${group.name || 'N/A'}` }))(groups);
      await this.setState({ ...this.state, userGroups: mappedGroups });
    }
    
    await this.props.thingsActions.getGroupVehicles({ groupId: companyInfo.groupId });
    this.setState({ ...this.state, loading: false });
  }

  searchVehicle = async (selectedOption) => {
    await this.setState({ ...this.state, things: selectedOption, skip: 0 });
  };

  selectNotification = async (selectedOption) => {
    await this.setState({ ...this.state, notificationSelected: selectedOption || [], skip: 0 });
  };

  toggle = () => {
    this.setState({ ...this.state, popoverOpen: !this.state.popoverOpen });
  };

  handleRangeChange = (ranges) => {
    const { selection } = ranges;
    this.setState({ 
      ...this.state, 
      dateRangePicker: { 
        ...this.state.dateRangePicker, 
        selection 
      } 
    });
  };

  async generateExcell() {
    try {
      this.setState({ ...this.state, loading: true });
      
      let obj = {};
      let vehicles = [];

      if (this.state.things && this.state.things.length > 0) {
        vehicles = _.map(this.state.things, (item) => item.value);
        if (vehicles.indexOf("All") !== -1) {
          vehicles = _.map(this.props.things, (item) => item._id);
        }
      }

      const interval = {
        startDate: moment(this.state.dateRangePicker.selection.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.state.dateRangePicker.selection.endDate).format('YYYY-MM-DD'),
      };

      obj['things'] = vehicles;
      obj['interval'] = interval;

      // Call the troubleshoot report action
      const result = await this.props.actions.generateTroubleshootReport(obj);
      
      if (result && result.downloadUrl) {
        this.setState({ 
          ...this.state, 
          downloadUrl: result.downloadUrl,
          showSuccessModal: true,
          loading: false 
        });
      } else {
        this.setState({ 
          ...this.state, 
          report: true, 
          loading: false 
        });
      }

    } catch (error) {
      console.error('Error generating troubleshoot report:', error);
      this.setState({ ...this.state, loading: false });
    }
  }

  navigateToLogs = () => {
    this.props.history.push("/download/reports");
  };

  toggleModel = () => {
    this.setState({ ...this.state, report: false });
  };

  toggleSuccessModal = () => {
    this.setState({ ...this.state, showSuccessModal: false });
  };

  handleDownload = () => {
    if (this.state.downloadUrl) {
      window.open(this.state.downloadUrl, '_blank');
    }
    this.toggleSuccessModal();
  };

  render() {
    const { loading, dateRangePicker, things, showSuccessModal, downloadUrl } = this.state;

    if (loading) {
      return <Spinner />;
    }

    let options = [{ value: 'All', label: 'ALL' }];
    
    this.props.things && this.props.things.map(thing => (
      options.push({ value: thing._id, label: `${thing.name || 'N/A'} - ${thing.imei || 'N/A'}` })
    ));

    return (
      <>
        <Modal visible={showSuccessModal} dialogClassName="delete-modal-dialog">
          <div>
            <button
              type="button"
              className="close close-x"
              aria-label="Close"
              onClick={this.toggleSuccessModal}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-heading">
            <h5 className="car-and-device-assig">Report Generated Successfully</h5>
          </div>
          <div className="modal-body">
            <h6>Your troubleshoot report has been generated successfully.</h6>
            <p>You can download it now or view it later from the reports section.</p>
          </div>
          <div className="modal-footer model-btn">
            <button
              className="btn auxo-primary-btn"
              onClick={this.handleDownload}
            >
              Download Now
            </button>
            <button
              className="btn auxo-secondary-btn"
              onClick={() => this.navigateToLogs()}
            >
              View All Reports
            </button>
            <button
              className="btn auxo-primary-btn"
              onClick={this.toggleSuccessModal}
            >
              Close
            </button>
          </div>
        </Modal>


        <Modal visible={this.state.report} dialogClassName="delete-modal-dialog">
          <div>
            <button
              type="button"
              className="close close-x"
              aria-label="Close"
              onClick={() => this.toggleModel()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-heading">
            <h5 className="car-and-device-assig">Report Request</h5>
          </div>
          <div className="modal-body">
            <h6>Your report is being generated. Please check log section.</h6>
          </div>
          <div className="modal-footer model-btn">
            <button
              className="btn auxo-primary-btn"
              onClick={() => this.navigateToLogs()}
            >
              View Reports
            </button>
            <button
              className="btn auxo-primary-btn"
              onClick={() => this.toggleModel()}
            >
              Cancel
            </button>
          </div>
        </Modal>

        <div className='row'>
          {/* <div className='col-lg-4 col-md-4 col-sm-4'>
            <div className='form-group'>
              <label>Select Devices</label>
              <Select
                name='form-field-name'
                value={things}
                isClearable={true}
                isSearchable={true}
                placeholder='Search Devices'
                onChange={this.searchVehicle}
                isMulti
                options={options}
              />
            </div>
          </div> */}

          {/* <div className='col-lg-4 col-md-4 col-sm-4'>
            <div className='form-group'>
              <label>Date Range</label>
              <div className="input-group">
                <input 
                  type="text" 
                  className="form-control" 
                  id="dateRangePicker" 
                  readOnly
                  value={`${moment(dateRangePicker.selection.startDate).format('DD/MM/YYYY')} - ${moment(dateRangePicker.selection.endDate).format('DD/MM/YYYY')}`} 
                />
                <div className="input-group-append">
                  <button className="btn btn-outline-secondary" type="button" id="dateRangePickerButton" onClick={this.toggle}>
                    <i className="fa fa-calendar"></i>
                  </button>
                </div>
              </div>
              <Popover placement="bottom" isOpen={this.state.popoverOpen} target="dateRangePickerButton" toggle={this.toggle}>
                <PopoverBody>
                  <DateRangePicker
                    ranges={[this.state.dateRangePicker.selection]}
                    onChange={this.handleRangeChange}
                    moveRangeOnFirstSelection={false}
                    retainEndDateOnFirstSelection={true}
                    rangeColors={['#3c8dbc']}
                  />
                </PopoverBody>
              </Popover>
            </div>
          </div> */}

          <div className="col-lg-2 col-md-2 col-sm-2" style={{ marginTop: "25px" }}>
            <button 
              className={`btn btn-primary search-btn search-button`} 
              style={{ padding: '7px 20px 7px 20px' }}  
              onClick={this.generateExcell.bind(this)}
              disabled={loading}
            >
              {loading ? 'Generating...' : 'Export'}
            </button>
          </div>
        </div>
      </>
    );
  }
}

TroubleShootReport.propTypes = {};
TroubleShootReport.defaultProps = {};

const mapStateToProps = state => ({
  vehiclesPlateNumber: state.things.vehiclesPlateNumber,
  notifications: state.users.notifications.notifications,
  notificationsCount: state.users.notifications.notificationsCount,
  things: state.things.groupVehicles,
  hasMoreNotifications: state.users.hasMoreNotifications
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Users.creators, dispatch),
  thingsActions: bindActionCreators(Things.creators, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TroubleShootReport));